@if (microphone) {
  <div data-hj-suppress class="speech-bubble mask-me" 
       appDynamicTheme
       [style.--mic-color]="microphone.color"
       [style.--mic-color-bright]="micColorBright">
    <!-- NOTE: div below is for compact timestamps -->
    @if (
      (showMessageMetadata$ | async) === false &&
      checkRender(message.updated_at, prevTimestamp) &&
      (currentTheme$ | async) === themes.color
    ) {
      <div class="speech-bubble__info" appSpeechBubbleText>
        {{ formatTime(message.updated_at) }}
      </div>
    }
    @if (
      (currentTheme$ | async) === themes.color &&
      (showMessageMetadata$ | async) === true
    ) {
      <p class="speech-bubble__info">
        {{
          isNaN(+microphone?.name)
            ? microphone?.name
            : 'Microphone ' + message.micColor.name
        }}
        - [
        {{
          (micSettings$ | async)?.language_in.substr(0, 2).toUpperCase() ||
            message.language.substr(0, 2).toUpperCase()
        }}
        @if (
          !translationsDisabled() &&
          (!(micSettings$ | async)?.language_in ||
            (micSettings$ | async)?.language_in !==
              (micSettings$ | async)?.language_out) &&
          (showMessageMetadata$ | async) === true
        ) {
          <i class="fa fa-arrow-right"></i>
          {{
            (micSettings$ | async)?.language_out.substr(0, 2).toUpperCase() ||
              (this.localLanguageOut$ | async).substr(0, 2).toUpperCase()
          }}
        }
        @if (translationsDisabled()) {
          <span class="translations-disabled-indicator" style="color: #ff9800; font-weight: 500;"> (Original)</span>
        }
        ]
        @if (message.timestamp) {
          <span> at {{ formatTime(message.updated_at) }} </span>
        }
      </p>
    }
    <div class="speech-bubble__content">
      @if ((currentTheme$ | async) !== themes.color) {
        <span
          class="speech-bubble__content__indicator"
          [ngStyle]="{ 'background-color': this.microphone.color }">
          {{ microphone?.name[0].toUpperCase() }}
        </span>
      }
      <span
        class="speech-bubble__content__container"
        [ngClass]="{ 'clean-theme': (currentTheme$ | async) === themes.clean }"
        [ngStyle]="{
          color: (currentTheme$ | async) === themes.color ? this.textColor : this.microphone.color
        }"
        [style.background-color]="
          (currentTheme$ | async) === themes.color ? this.microphone.color : ''
        ">
        @if (
          (currentTheme$ | async) !== themes.color &&
          (showMessageMetadata$ | async) === true
        ) {
          <span class="speech-bubble__content__container__timestamp">
            {{
              isNaN(+microphone?.name)
                ? microphone?.name
                : 'Microphone ' + message.micColor.name
            }}
            - [
            {{
              (micSettings$ | async)?.language_in.substr(0, 2).toUpperCase() ||
                message.language.substr(0, 2).toUpperCase()
            }}
            @if (
              !(micSettings$ | async)?.language_in ||
              (micSettings$ | async)?.language_in !==
                (micSettings$ | async)?.language_out
            ) {
              <i class="fa fa-arrow-right"></i>
              {{
                (micSettings$ | async)?.language_out
                  .substr(0, 2)
                  .toUpperCase() ||
                  (this.localLanguageOut$ | async).substr(0, 2).toUpperCase()
              }}
            }
            ] - {{ formatTime(message.updated_at) }}</span
          >
        }
        <!-- NOTE: Glow theme change  -->
        @if (
          (showMessageMetadata$ | async) === false &&
          checkRender(message.updated_at, prevTimestamp) &&
          (currentTheme$ | async) !== themes.color
        ) {
          <span class="speech-bubble__content__container__timestamp">{{
            formatTime(message.updated_at)
          }}</span>
        }
        @if (isDelayActive()) {
          <!-- Soundshape QR with translation delay: word-by-word typing -->
          <span
            class="speech-bubble__content__container__text"
            appSpeechBubbleText
            appStableText
            [documentId]="message.documentID"
            [isFinal]="message.is_final">
          </span>
        } @else if (isQRUser && !isMicrophonekitQR) {
          <!-- Soundshape QR: Backend translations (no delay) -->
          <span
            class="speech-bubble__content__container__text"
            appSpeechBubbleText>{{
              message.message | backendTranslate
                : message.transcripts
                : message.language
                : (localLanguageOut$ | async)
                : translationsDisabled()
            }}</span>
        } @else {
          <!-- Non-QR / Microphonekit QR: Frontend translation -->
          <span
            class="speech-bubble__content__container__text"
            appSpeechBubbleText>{{
              (message.message
                | liveTranslate
                  : {
                      languageIn: (micSettings$ | async)?.language_in || message.language,
                      languageOut: (micSettings$ | async)?.language_out || (localLanguageOut$ | async)
                    }
                | async) ?? message.message
            }}</span>
        }
      </span>
      @if ((currentTheme$ | async) === themes.color) {
        <span
          [style.border-right-color]="message.micColor.hex"
          class="speech-bubble__content__pointer">
        </span>
      }
    </div>
    @if ((localSettings$ | async)?.showConfidenceScore) {
      <p>
        {{ message.confidence }}
      </p>
    }
  </div>
}
